import { lazyLoad } from 'utils/loadable';

export const EntityMaterialCreatePage = lazyLoad(
  () => import('./index'),
  module => module.EntityMaterialCreatePage
);
